<div class="card">
    <div class="card-body">
        <div class="mb-4 d-md-flex align-items-center justify-content-between">
            <div>
                <h4><span *ngIf="!isEdit">Add New</span><span *ngIf="isEdit">Update</span> User</h4>
                <p>Basic info, like your name and address on this account.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form [formGroup]="formGroup" (submit)="onSubmit()">
                    <div class="row">
                        <div class="col form-group mb-3">
                            <input type="text" class="form-control" placeholder="Person Name" formControlName="contactPersonName">
                        </div>
                        <div class="col form-group mb-3">
                            <input type="email" class="form-control" placeholder="Email" formControlName="email">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group mb-3">
                            <input type="text" class="form-control" placeholder="Contact No" formControlName="phone">
                        </div>
                        <div class="col form-group mb-3">
                            <ng-select 
                                [items]="roles"
                                bindLabel="name"
                                bindValue="name"
				                placeholder="Select Role"
                                formControlName="position"
                            >
                            </ng-select>
                        </div>
                    </div>
                    <div class="text-end">
                        <button class="btn btn-primary ml-2" type="submit">{{isEdit?'Update':'Add'}} User</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="card">
        <div class="card-body">
            <div class="mb-3 d-flex align-items-center justify-content-between">
                <h4 class="mb-2 fw-bolder">Users List</h4>
                <div class="mb-2">
                    <input
                        type="text"
                        [(ngModel)]="searchText" class="searchBox" (keyup)="filteredUsers()"
                        class="form-control mb-3"
                        placeholder="Search user by name"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <ngx-datatable
                            #table
                            
                            [rows]="usersList"
                            [columnMode]="columnMode"
                            [headerHeight]="50"
                            [footerHeight]="50"
                            [limit]="10"
                            [rowHeight]="rowHeight"
                            [scrollbarH]="true"
                        >
                            
                            <ngx-datatable-column name="Sr. No." [width]="70">
                                <ng-template let-rowIndex="rowIndex" let-row="row" let-value="value" ngx-datatable-cell-template>
                                    {{ rowIndex+1 }}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Person Name" [width]="150">
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                    {{row['contactPersonName']}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Email" [width]="200">
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                    {{row['email']}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Contact No" [width]="110">
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                    {{row['phone']}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Role" [width]="120">
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{ row['position']}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Assign Table" [width]="200">
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                    <span class="userDa">{{ removePrefix(row.assignedTable)}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Created At" [width]="90">
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{ row.created | date:'dd-MM-yyyy'}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column [sortable]="false" name="Action" [width]="140">
                                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                    <button class="btn btn-primary ml-2 circleBtn edit-btn-svg" type="button" (click)="editUser(row)"><!--<i class="feather icon-edit"></i>-->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path></svg>
									</button>
                                  <!--  <button class="btn btn-primary ml-2 circleBtn lock-btn-svg" type="button" (click)="changePassword(row._id)"><i class="feather icon-lock"></i>-->
									<!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
									</button> -->
                                    <button class="btn btn-warning ml-2 circleBtn del-btn-svg" type="button" (click)="deleteUser(row._id)"><!--<i class="feather icon-trash"></i>-->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>
									</button>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                        <!-- <ngx-datatable
                            #myTable
                            class="bootstrap"
                            [rows]="rows"
                            [columnMode]="ColumnMode.force"
                            [headerHeight]="50"
                            [footerHeight]="50"
                            [limit]="10"
                            [rowHeight]="55"
                            [scrollbarV]="true"
                            [scrollbarH]="true"
                            (page)="onPage($event)">

                                <ngx-datatable-column *ngFor="let col of columns" [name]="col.name" [prop]="col.prop"  [flexGrow]="(col.prop == '_id')?1:3" [cellTemplate]="col.prop === '_id' ? idTemplate : (col.prop === 'created' ? createdTemplate : (col.prop === 'action' ? actionTemplate : (col.prop === 'assignedTable' ? assignTabTemplate : undefined)))"></ngx-datatable-column>
                        </ngx-datatable> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
